var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"survey__header"},[_c('h1',{staticClass:"survey__scenario"},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.message))]})],2),_c('test-illustration',{attrs:{"image":_vm.image}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }